import { ColDef, SizeColumnsToFitGridStrategy } from 'ag-grid-community';

import { ConversationIcon, GridIcon, TargetIcon } from '@treams/treams-icons';
import { Prompt } from '@treams/treams-network';

export const defaultColDef: ColDef = {
	sortable: true,
	filter: true,
	floatingFilter: false,
	comparator: (valueA, valueB) => {
		if (valueA == null && valueB == null) return 0;
		if (valueA == null) return -1;
		if (valueB == null) return 1;

		const a = String(valueA).toLowerCase();
		const b = String(valueB).toLowerCase();

		return a.localeCompare(b);
	},
};

export const autoSizeStrategy: SizeColumnsToFitGridStrategy = { type: 'fitGridWidth' };

export const GLOBAL_WORKSPACE_ID = '0000-0000-0000';

export const prompts = [
	{
		id: Prompt.ConversationInsightsManager,
		slug: 'conversation-insights-manager',
		title: 'Conversation Insights: Manager',
		color: 'manager',
		icon: <ConversationIcon />,
	},
	{
		id: Prompt.ConversationInsightsEmployee,
		slug: 'conversation-insights-employee',
		title: 'Conversation Insights: Employee',
		color: 'employee',
		icon: <ConversationIcon />,
	},
	{
		id: Prompt.TalkingPoints,
		slug: 'talking-points',
		title: 'Talking Points',
		color: 'primaryVibrant',
		icon: <TargetIcon />,
	},
	{
		id: Prompt.TalentInsights,
		slug: 'talent-insights',
		title: 'Talent Insights',
		color: 'pink',
		icon: <GridIcon />,
	},
	// {
	// 	id: Prompt.GoalsInsights,
	// 	slug: 'goals-insights',
	// 	title: 'Goals Insights',
	// 	color: 'green',
	// 	icon: <TargetIcon />,
	// },
];
